import { render, staticRenderFns } from "./OptionView.vue?vue&type=template&id=52d07ddd&lang=pug"
import script from "./OptionView.vue?vue&type=script&lang=js"
export * from "./OptionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports